import styled from 'styled-components'
// styled components
import Paper from 'components/UI/Paper'
// views
import { ErrorText } from 'components/UI/ErrorMessage'

export const AuthPaper = styled(Paper)`
  && {
    padding: 40px;
    height: 100%;
    display: flex;
  }
`

export const Logo = styled.img.attrs({ src: '/images/logo.png' })`
  width: 100%;
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  > span {
    width: 100%;
    border-top: 1px solid lightgrey;
  }

  @media (max-width: 768px) {
    > div {
      width: 100%;
      padding: 0 20px;
    }

    button {
      min-width: 100%;
    }
  }
`

export const MicrosoftLoginButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`

export const AuthForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 334px;

  a {
    margin-top: -16px;
  }

  ${ErrorText} {
    margin-top: -16px;
  }
`

export const AuthHeader = styled.div`
  display: flex;
  align-items: end;
  height: 64px;
  font-size: 24px;
`
